export default __webpack_public_path__ + "static/logo-brasserie-heritage-5fbf49e827193c26d8f4b3cf744fee17.png";